import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const subs = new Set();
export const refreshHeaderFooter = () => api.get("/site/header-footer").then((r) => { cache = r.data; subs.forEach((f) => f(r.data)); }).catch(() => {});

export function useHeaderFooter() {
  const [d, setD] = useState(cache);
  useEffect(() => {
    subs.add(setD);
    if (!cache) refreshHeaderFooter();
    return () => { subs.delete(setD); };
  }, []);
  return d;
}
